import { useRouter } from 'next/router'
import { useTranslation } from 'react-i18next'

const JobDescription = (props) => {
	const router = useRouter()
	const { t } = useTranslation()

	const formatHTML = (text) => {
		if (!text) {
			return ''
		}
		return text
			.replace(/<\/b>/g, '\n')
			.replace(/<\/br>/g, '\n')
			.replace(/<\/p>/g, '\n')
			.replace(/(<([^>]+)>)/gi, '')
			.replace(/<p>\s<\/p>/g, '')
			.replace(/&lt;/g, '')
			.replace(/&gt;/g, '')
			.replace(/\t/g, '')
			.replace(/<ol>/g, '')
			.replace(/<\/ol>/g, '')
			.replace(/<li>/g, '')
			.replace(/<\/li>/g, '')
			.replace(/<p>/g, '')
			.replace(/<\/p>/g, '')
			.replace(/<div>/g, '')
			.replace(/<\/div>/g, '')
			.replace(/\r\n\r\n/g, '')
			.replace(/<ul>/g, '')
			.replace(/<\/ul>/g, '')
			.replace(/<br\s*[\/]?>/gi, '')
			.replace(/<span>/g, '')
			.replace(/<\/span>/g, '')
			.replace(/<hr>/g, '')
			.replace(/<\/hr>/g, '')
			.replace(/<b>/g, '')
			.replace(/<\/b>/g, '')
			.replace(/<strong>/g, '')
			.replace(/<\/strong>/g, '')
			.replace(/<pre>/g, '')
			.replace(/<\/pre>/g, '')
			.replace(/&nbsp;/g, ' ')
	}

	const { job } = props
	let description = ''
	if (router.locale === 'cn' && (job.descriptionChinese !== null && job.descriptionChinese !== '')) description = job.descriptionChinese
	else if (router.locale === 'my' && (job.descriptionMalay !== null && job.descriptionMalay !== '')) description = job.descriptionMalay
	else description = job.description
	
	let requirements = ''
	if (router.locale === 'cn' && (job.requirementsChinese !== null && job.requirementsChinese !== '')) requirements = job.requirementsChinese
	else if (router.locale === 'my' && (job.requirementsMalay !== null && job.requirementsMalay !== '')) requirements = job.requirementsMalay
	else requirements = job.requirements

	return <>
		<p className='fw-bolder'>{t('job.desc')}</p>
		<pre dangerouslySetInnerHTML={{__html: formatHTML(description)}} />
		{requirements && <>
			<p className='fw-bolder mt-4'>Job Requirements</p>
			<pre dangerouslySetInnerHTML={{__html: formatHTML(requirements)}} />
		</>}
	</>
}

export default JobDescription
